import Controller from '@ember/controller';

export default class LinkExpiredController extends Controller {}
